import SocketService from '../SocketService';
export var scoreListingRequest = function (token) {
    return SocketService.createEncodedMessage({
        kind: 'scoreListingRequest',
        scoreListingRequest: {
            token: token
        }
    });
};
